import { render } from "./AppWalletSection.vue?vue&type=template&id=5ee24d7c"
import script from "./AppWalletSection.vue?vue&type=script&lang=js"
export * from "./AppWalletSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__